import styled from "styled-components";
import { position, PositionProps } from "styled-system";

import Box from "../../layout/boxes/Box/Box";

export const StyledMenu = styled(Box)`
	position: fixed;
	top: 0;
	left: 0;
	background-color: ${({ theme }) => theme.palette.hexForRole("bg_dark")};
	height: 0px;
	width: 100vw;
	transition: height 400ms ease-in-out;
	overflow: hidden;
	border-bottom-right-radius: ${({ theme }) => theme.space.lg};

	&.HamburgerMenu--expand {
		height: 100vh;
	}
`;

export const StyledNavigation = styled.ul<PositionProps>`
	margin: 0;
	padding: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	transform: translateX(-50%);
	${position}
`;

export const StyledNavigationContainer = styled.nav`
	opacity: 0;
	transition: all 800ms ease-in-out;

	&.HamburgerMenu__nav-container--expand {
		opacity: 1;
	}
`;
